
'format es6';

import $ from 'jquery';
import Promise from 'Promise';
import gsap from 'greensock';
import { factory as sectionFactory } from './Section';

require('../../views-compiled/question.profile');

const EASING = gsap.Expo;

function ProfileQuestion() {

	this.templateName = 'question.profile.htm';

	let data;
	let radios;
	let backlink;

	this.setAnimation = (tl, rootNode, setInEndTime) => {
		tl.from(rootNode, 0.1, { opacity: 0, ease: EASING.easeIn });
		const animateInFinish = setInEndTime();
		tl.to(rootNode, 0.1, { opacity: 0, ease: EASING.easeOut }, animateInFinish);
		return tl;
	};

	this.setData = (vals) => {
		data = vals;
	};

	this.init = () => Promise.resolve(data);

	this.activate = () => {
		radios = $('[data-option]', this.sectionNode);
		radios.on('click.cursus', (e) => {
			e.preventDefault();
			const clicked = $(e.target);
			const val = clicked.data('option');
			this.animateOut().then(() => {
				this.next && this.next(val);
				this.next = null;
			});
		});
		backlink = $('.q-back a', this.sectionNode);
		backlink.on('click.cursus', (e) => {
			e.preventDefault();
			this.animateOut().then(() => {
				this.prev && this.prev();
				this.prev = null;
			});
		});
	};

	this.deactivate = () => {
		radios && radios.off('.cursus');
	};

	return this;
}


export function factory(instance) {
	return ProfileQuestion.call(sectionFactory(instance || {}));
}
